// First import: turns the console off unless TROUBLESHOOTING (see the module).
import { alwaysLog } from "./consoleGate_v2.js";
import { zoom } from "./zoom_v2.js";
import { identityService } from "./profile/identityService_v2.js";
import { matchService } from "./matches/matchService_v2.js";
import { colors } from "./colors_v2.js";
import { hamburger } from "./hamburger_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { Amplify } from "aws-amplify";
import { TROUBLESHOOTING } from "./constants_v2.js";
import { router } from "./router_v2.js";
import { installSessionGuard } from "./sessionGuard_v2.js";

const appState = {};

const loadConfiguration = async () => {
  const hostName = document.location.hostname;

  const fetchConfig = async (filename) => {
    const response = await fetch(`https://${hostName}/${filename}`);
    if (!response.ok) throw new Error(`Failed to load ${filename}`);
    return (await response.text()).trim();
  };

  appState.API_URL = await fetchConfig("API_URL.txt");
  appState.buildNumber = await fetchConfig("buildNumber.txt");
  appState.APPSYNC_HTTP_ENDPOINT = await fetchConfig(
    "APPSYNC_HTTP_ENDPOINT.txt",
  );

  // The one line that always shows in the console.
  alwaysLog("Topagon build: " + appState.buildNumber);
};

// initialize the app
try {
  console.log("🚀 App initialization starting...");
  
  console.log("📡 Loading configuration...");
  await loadConfiguration();
  console.log("✅ Configuration loaded successfully");

  // One clear message when the server ends this session (password changed
  // or reset, account deleted). utils-app is loaded when it's needed, so
  // this adds no import to app_v2.js (see "circular imports" in lessons).
  installSessionGuard({
    apiURL: appState.API_URL,
    onSessionEnded: async () => {
      const { utilsApp } = await import("./utils-app_v2.js");
      utilsApp.renderSessionEndedPop();
    },
  });

  console.log("🔧 Configuring Amplify...");
  //Configure Amplify AFTER data is loaded
  Amplify.configure({
    API: {
      Events: {
        endpoint: `https://${appState.APPSYNC_HTTP_ENDPOINT}/event`,
        region: "us-east-2",
        defaultAuthMode: "lambda",
      },
    },
  });
  console.log("✅ Amplify configured successfully");

  const handleIDCache = () => console.log(identityService.getCache());
  const handleMatchCache = () => console.log(matchService.getCache());

  console.log("🛠️ Setting up troubleshooting UI...");
  if (TROUBLESHOOTING) {
    document.getElementById("troubleshootingInfo6").innerHTML =
      `<button id="logIDCache">IDCache</button>`;
    document.getElementById("troubleshootingInfo5").innerHTML =
      `<button id="logMatchCache">matchCache</button>`;
    eventHub.registerEvent("click", "logIDCache", handleIDCache);
    eventHub.registerEvent("click", "logMatchCache", handleMatchCache);
  }
  console.log("✅ Troubleshooting UI ready");

  console.log("🎮 Initializing core systems...");
  eventHub.initEventHub();
  zoom.setDefault();
  colors.setScheme("muted");
  console.log("✅ Core systems initialized");

  console.log("🍔 Setting up hamburger menu...");
  eventHub.registerEvent("click", "hamburger", hamburger.handleClick);
  console.log("✅ Hamburger menu ready");
  
  console.log("💬 Initializing chat system...");
  // Initialize chat system
  const { chat } = await import("./chat/chat_v2.js");
  await chat.init();
  
  // Make chat available globally for colors module to call updateColors
  window.chat = chat;
  
  console.log("✅ Chat system initialized");
  
  console.log("✅ App initialization completed successfully!");
} catch (error) {
  console.error("💥 Critical failure during app initialization:", error);
  console.error("📊 Error stack:", error.stack);
  document.getElementById("loading").innerText =
    "Failed to load configuration. Please refresh.";
}

export const app = {
  getAPI_URL: () => appState.API_URL,
  getAppSyncHttpEndpoint: () => appState.APPSYNC_HTTP_ENDPOINT,
};

console.log("🛣️ Starting router...");
await router.route();
console.log("✅ Router completed successfully!");
